<template>
  <ol class="breadcrumb">
    <slot></slot>
  </ol>
</template>
<script>
export default {
  name: 'bs-breadcrumb'
}
</script>



// WEBPACK FOOTER //
// src/components/breadcrumb/Breadcrumb.vue?76a20c48